import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter } from "react-router-dom";
import { Toaster } from "sonner";
import { App } from "./App";
import { AuthProvider } from "./auth/AuthProvider";
import { TenantRuntimeProvider } from "./config/TenantRuntime";
import "@yatta/ui/styles.css";
import "./styles.css";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

const container = document.getElementById("root");
if (!container) throw new Error("Root container not found.");

ReactDOM.createRoot(container).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <TenantRuntimeProvider>
          <AuthProvider>
            <App />
          </AuthProvider>
          <Toaster richColors position="top-right" />
        </TenantRuntimeProvider>
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>,
);
